module.exports = __webpack_public_path__ + "img/en.a2a4e84e.png";